import React from 'react';

const AboutUsComponent = () => {
  return (
    <div className="aboutus-outer">
        <h1>DESPRE NOI</h1>
        <p>
        Compania<strong> ECO SUN CRIS SRL</strong> este lider pe piața din România în furnizarea de servicii de reparații și întreținere pentru pompe de vacuum și pompe de înaltă presiune utilizate în domeniul vidanjării. Cu o experiență de peste 15 ani în industrie, ne dedicăm furnizării de soluții eficiente și de încredere pentru echipamentele de vidanjare, esențiale în procesele de curățare și întreținere a sistemelor de canalizare și fose septice.
  </p>
</div>

  );
};

export default AboutUsComponent;